
import Vue from 'vue';
import { ObserveVisibility } from 'vue-observe-visibility';
Vue.directive('observe-visibility', ObserveVisibility);

export default Vue.extend({
  props: {
    dataProps: {
      type: Object,
      default() {
        return {
          introduction: null,
          step: null,
        };
      },
    },
  },
  data() {
    return {
      footprints: [
        {
          top: 10,
          right: 10,
          rotate: 0,
        },
        {
          top: 80,
          right: 30,
          rotate: -25,
        },
        {
          top: 100,
          right: 130,
          rotate: -10,
        },
        {
          top: 170,
          right: 130,
          rotate: -20,
        },
        {
          top: 180,
          right: 240,
          rotate: 0,
        },
        {
          top: 260,
          right: 250,
          rotate: -30,
        },
      ],
    };
  },
  methods: {
    visibilityChanged(visibility: any, element: any) {
      element.target.style.visibility = visibility === true ? 'visible' : 'hidden';
    },
    step(id: number, key: string) {
      return this.$props.dataProps.step[id - 1][key];
    },
  },
});
